export const apiErrorHelper = (router, error) => {
    router.push({ path: 'error' });
    if(router.app.$logger){
        router.app.$logger.error('apiErrorHelper: ', error);
    }
};
